import { useState } from 'react';
import { Box } from '../../../components/UI-CHAKRA/Box';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { useIsMobile } from '../../../helpers/useIsMobile';
import { usePrescriptionStore } from '../../../stores/prescriptionStore';
import { NewModelDrawer } from './NewModelDrawer';

export function SaveAsModelButton() {
  const [isOpen, setIsOpen] = useState(false);
  const prescriptionItemsAmount = usePrescriptionStore((store) => store.prescriptionItemsAmount());
  const isMobile = useIsMobile();
  const isDisabled = prescriptionItemsAmount === 0;

  if (isDisabled) return null;

  return (
    <>
      <Box
        as={'button'}
        onClick={() => setIsOpen(true)}
        bg={'transparent'}
        border={'none'}
        cursor={'pointer'}
        p={'8px 4px'}
        whiteSpace={'nowrap'}
        data-testid={'salvar-como-modelo-button'}
      >
        <Text fontSize={'14px'} fontWeight={500} color={'primary.main'} textDecoration={'underline'}>
          {isMobile ? 'Salvar como novo modelo' : 'Salvar prescrição como novo modelo'}
        </Text>
      </Box>
      <NewModelDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
